/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Add_Frame_To_EndInputs */



/**
* | output |
* | --- |
* | "Add 1 Frame To End" |
*
* @param {Shortcut_Keys_Name_Add_Frame_To_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_add_frame_to_end = /** @type {((inputs?: Shortcut_Keys_Name_Add_Frame_To_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Add_Frame_To_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter 1 image a la fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge am Ende 1 Frame hinzu")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi 1 fotogramma alla fine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить 1 рамку в конец")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir 1 fotograma al final")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在末尾添加 1 帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後に1フレームを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंत में 1 फ्रेम जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar 1 quadro ao final")
	return /** @type {LocalizedString} */ ("Add 1 Frame To End")
});